"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Link = _interopRequireDefault(require("./Link"));
var _default = exports["default"] = _Link["default"];